export const data = [
  { message: 'Tom created a new SplitLink.', date: new Date(), type: 'SplitLink' },
  { message: 'Tom created a new SplitLink.', date: new Date(), type: 'SplitLink' },
  { message: 'Your merchant Amazon is active.', date: new Date(), type: 'Merchant' },
  { message: 'Tom created a new SplitLink.', date: new Date(), type: 'SplitLink' },
  { message: 'Your merchant Amazon is active.', date: new Date(), type: 'Merchant' },
  { message: 'Tom created a new SplitLink.', date: new Date(), type: 'SplitLink' }
];